
export const totalSteps = 5;

export const getTooltipContent = (message, index) => (
  <>
    <div
      style={{
        position: 'absolute',
        top: '12px',
        left: '16px',
        fontSize: '12px',
        textTransform: 'uppercase',
        letterSpacing: '0.4px',
        color: '#000',
        padding: '4px 8px',
      }}
    >
      Step {index} of {totalSteps}
    </div>
    <div
      style={{
        paddingTop: '24px',
        fontSize: '16px',
        color: '#111',
      }}
    >
      {message}
    </div>
  </>
);

export const joyrideStyles = {
  buttonClose: { display: 'none' },
  options: {
    zIndex: 9999,
    arrowColor: '#fefefe',
    backgroundColor: '#fefefe',
  },
  tooltip: {
    position: 'relative',
    padding: '20px',
    fontSize: '16px',
    borderRadius: '10px',
    backgroundColor: '#fefefe',
    color: '#222',
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
    maxWidth: '400px',
    wordBreak: 'break-word',
  },
  buttonNext: {
    backgroundColor: '#000',
    color: '#fff',
    borderRadius: '4px',
    padding: '8px 16px',
    fontWeight: 'bold',
    border: 'none',
    cursor: 'pointer',
  },
  buttonBack: {
    color: '#000',
    border: 'none',
    borderRadius: '4px',
    padding: '8px 16px',
    fontWeight: 'bold',
    cursor: 'pointer',
    marginRight: '8px',
  },
  buttonSkip: {
    backgroundColor: '#e0e0e0',
    color: '#333',
    borderRadius: '4px',
    padding: '8px 16px',
    fontWeight: 'bold',
    border: 'none',
    cursor: 'pointer',
    marginRight: '8px',
  },
};

export const joyrideLocale = (stepIndex) => ({
  back: '← Back',
  last: 'End Tour',
  next: stepIndex === 0 ? 'Start Tour' : 'Next →',
  skip: 'Skip',
});

export const steps = [
  {
    target: 'body',
    content: (
      <div>
        <div style={{ fontWeight: 'bold', fontSize: '18px', marginBottom: '8px' }}>
          Welcome to EAUC👋
        </div>
        <div>
          Get started by selecting the services you would like to add to your personalized dashboard.
        </div>
      </div>
    ),
    placement: 'center',
    disableBeacon: true,
    locale: {
      next: 'Start Tour',
    },
  },
  {
    target: '[data-tour-id="integrations-tab"]',
    content: getTooltipContent('This tab lets you select the services you want to view in the Calendar.', 1),
    placement: 'right',
    disableBeacon: true,
  },
  {
    target: '#joyride-row-marker',
    content: getTooltipContent('Business Services in compliance with the Service Registry', 2),
    placement: 'right',
    disableBeacon: true,
    disableScrolling: true,
  },
  {
    target: '#integration-search',
    content: getTooltipContent('Use the search bar to quickly find the service you need.', 3),
    placement: 'bottom',
    disableBeacon: true,
  },
  {
    target: '#joyride-checkbox-marker',
    content: getTooltipContent('Use the checkboxes to connect services with your calendar.', 4),
    placement: 'top',
    disableBeacon: true,
  },
  {
    target: '[data-tour-id="save-button"]',
    content: getTooltipContent('Hit Save to view your selected services in the calendar.', 5),
    placement: 'bottom',
    disableBeacon: true,
  },
];
